import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { LoginGuardGuard } from "./guards/login-guard.guard";
import { RoleGuardGuard } from "./guards/RoleGuard/role-guard.guard";
import { LoginComponent } from "./sections/login/login.component";
import { PagenotfoundComponent } from "./components/shared/pagenotfound/pagenotfound.component";
import { DispositivosComponent } from "./sections/dispositivos/dispositivos.component";
import { GraphicsComponent } from "./sections/visualizacionFolder/graphics/graphics.component";
import { DashboardComponent } from "./sections/dashboard/dashboard.component";
import { OrdersComponent } from "./sections/orders/orders.component";
import { GunningsComponent } from "./sections/gunnings/gunnings.component";
import { TundishComponent } from "./sections/tundish/tundish.component";
import { StatusComponent } from "./sections/status/status.component";
import { AlarmasComponent } from "./sections/alarmas/alarmas.component";
import { UsersComponent } from "./sections/users/users.component";
import { BbddComponent } from "./sections/bbdd/bbdd.component";
import { arbolDispositivos } from "./services/arbolDispositivos/arbolDispositivos.component";
import { arbolDatos } from "./components/arbolDatos/arbolDatos.component";
import { InformesComponent } from "./components/informes/informes.component";
import { InformeFabricaComponent } from "./components/informes/informe-fabrica.component";
import { InformeMaeComponent } from "./components/informes/informe-mae.component";
import { EstructuraCampoComponent } from "./sections/estructuraCampo/estructuraCampo.component";
import { EstructuraCampoNavComponent } from "./components/estructuraCampoNav/estructuraCampoNav.component";
import { EntradasNavComponent } from "./components/entradas-nav/entradas-nav.component";
import { NoCredentialsComponent } from "./components/noCredentials/no-credentials.component";
import { MapaComponent } from "./sections/mapa/mapa.component";
import { environment } from "src/environments/environment";
import { IridiumEventsComponent } from "./components/iridium-events/iridium-events.component";
import { FeatureGuard } from "./guards/FeatureGuard/feature-guard.guard";
import { UltimasMedicionesComponent } from "./sections/ultimas-mediciones/ultimas-mediciones.component";
import { TablasComponent } from "./sections/tablas/tablas.component";
import { EstructuraCampoAdminComponent } from './sections/estructura-campo-admin/estructura-campo-admin.component';

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./module/home/home.module").then(
        (m) => m.HomeModule
      ),
    canActivate: [LoginGuardGuard],
  },
  {
    path: "swhc",
    loadChildren: () =>
      import("./module/swhc3d/swhc3d.module").then(
        (m) => m.Swhc3dModule
      ),
      canActivate: [FeatureGuard, LoginGuardGuard],
      data: {
        expectedFeature: ["cranes"],
      },
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./module/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
    canActivate: [LoginGuardGuard],
  },
  {
    path: "devices",
    loadChildren: () =>
      import("./module/dispositivos/dispositivos.module").then(
        (m) => m.DispositivosModule
      ),
    canActivate: [LoginGuardGuard],
    data: {
      expectedRole: ["devices", "admin"],
    },
  },
  {
    path: "graphics",
    loadChildren: () =>
      import("./module/graphics/graphics.module").then((m) => m.GraphicsModule),
    canActivate: [LoginGuardGuard],
  },
  {
    path: "tables",
    loadChildren: () =>
      import("./module/tablas/tablas.module").then((m) => m.TablasModule),
    canActivate: [RoleGuardGuard, FeatureGuard, LoginGuardGuard],
    data: {
      expectedFeature: ["tables"],
      expectedRole: ["tables-manager", "admin"],
    },
  },
  {
    path: "alarmas",
    loadChildren: () =>
      import("./module/alarma/alarma.module").then((m) => m.AlarmaModule),
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["alarms", "admin"],
    },
  },
  {
    path: "iridium",
    component: IridiumEventsComponent,
    canActivate: [RoleGuardGuard, FeatureGuard, LoginGuardGuard],
    data: {
      expectedFeature: ["iridium"],
      expectedRole: ["iridium", "admin"],
    },
  },
  {
    path: "users",
    component: UsersComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["user_manager", "admin", "alarms", "magna_admin"],
    },
  },
  {
    path: "login",
    loadChildren: () =>
      import("../app/module/login/login.module").then((m) => m.LoginModule),
  },
  // { path: "login", component: LoginComponent },
  { path: "pageNotFound", component: PagenotfoundComponent },
  {
    path: "bbdd",
    component: BbddComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin"],
    },
  },
  {
    path: "disp/:uuid",
    component: arbolDispositivos,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin"],
    },
  },
  {
    path: "dato/:uuid",
    component: arbolDatos,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "node-alarms"],
    },
    runGuardsAndResolvers: "always",
  },
  {
    path: "estructuracampo",
    component: EstructuraCampoComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "node-alarms"],
    },
  },
  {
    path: "estructuracampoadmin/:uuid/:nombre", component: EstructuraCampoAdminComponent, canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "node-alarms"]
    }
  },
  {
    path: "mapa",
    loadChildren: () =>
      import("./module/mapa/mapa.module").then((m) => m.MapaModule),
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "map"],
    },
  },
  {
    path: "ultimasmediciones",
    component: UltimasMedicionesComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "last_measures"],
    },
  },
  {
    path: "gateways/:uuid",
    component: EstructuraCampoNavComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "node-alarms"],
    },
  },
  {
    path: "source/:uuid",
    component: EntradasNavComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "node-alarms"],
    },
  },
  {
    path: "informes",
    component: InformesComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "informs", "alarms"],
    },
  },
  {
    path: "informe-fabrica/:modo/:uuid",
    component: InformeFabricaComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin"],
    },
  },
  {
    path: "informe-mae/:modo/:uuid",
    component: InformeMaeComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin"],
    },
  },
  {
    path: "orders",
    loadChildren: () =>
      import("./module/orders/orders.module").then((m) => m.OrdersModule),
    canActivate: [LoginGuardGuard, FeatureGuard],
    data: {
      expectedFeature: ["orders"],
    },
  },
  {
    path: "gunnings",
    component: GunningsComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "magna_admin", "magna_user"],
    },
  },
  {
    path: "tundish",
    component: TundishComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "magna_admin", "magna_user"],
    },
  },
  {
    path: "incidents",
    loadChildren: () =>
      import("./module/incidents/incidents.module").then(
        (m) => m.IncidentsModule
      ),
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "magna_admin", "magna_user"],
    },
  },
  {
    path: "status",
    component: StatusComponent,
    canActivate: [LoginGuardGuard, RoleGuardGuard],
    data: {
      expectedRole: ["admin", "magna_admin", "magna_user"],
    },
  } ,
  { path: "pageNotFound", component: PagenotfoundComponent },
  { path: "accessDenied", component: NoCredentialsComponent },
  { path: "**", redirectTo: "pageNotFound" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
